export var CarrierNotAvailable = function CarrierNotAvailable(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return CarrierNotAvailableBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return CarrierNotAvailableBuilder(strictLocalize).getDescription();
    }
  };
};
var CarrierNotAvailableBuilder = function CarrierNotAvailableBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "OmGYKr",
        defaultMessage: [{
          "type": 0,
          "value": "Vervoerder niet beschikbaar"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "0tajdp",
        defaultMessage: [{
          "type": 0,
          "value": "De geselecteerde vervoerder verzendt niet naar het ingevoerde adres. Je kunt een andere vervoerder selecteren of Met eigen vervoerder verzenden kiezen."
        }]
      })];
    }
  };
};